import { getDefaultClient } from '@dynamic-labs-sdk/client/core';

import { addBitcoinInjectedWalletsExtension } from '../injected/addBitcoinInjectedWalletsExtension';
import { addWaasBitcoinExtension } from '../waas/addWaasBitcoinExtension';

/**
 * Adds the Bitcoin extension to the Dynamic client.
 *
 * This is a convenience function that adds both the Bitcoin Injected Wallets extension
 * and the Dynamic WaaS Bitcoin extension, enabling support for all Bitcoin wallet types
 * including injected wallets (MagicEden, Xverse, Unisat, and more) and embedded wallets
 * managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */

export const addBitcoinExtension = (client = getDefaultClient()): void => {
  addBitcoinInjectedWalletsExtension(client);
  addWaasBitcoinExtension(client);
};
